// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/taf-change-groups.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/taf-change-groups/taf-change-groups.js';

mount([g0]);
